import React, { useEffect, useState, Fragment } from 'react'
import { useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import * as queryString from 'query-string'

import {
	Footer,
	Header1,
	Header2,
	UpsellMain1,
	UpsellMain2,
} from '../../components/upsell'
import { getIsLegalFlow, getUserId } from '../../redux/slices/userSlice'
import { ampEvent, ampSetUserProperty } from '../../utils/amplitude'
import { paramsToQuery } from '../../utils/historyDecorators'
import { upsellsTypes } from './upsellsTypes'
import { upsellsList } from './upsellsList'

import './styles.scss'
import { getInitialPrice, getUpsellPrice } from '../../redux/slices/configSlice'

const Upsell = () => {
	const { pathname } = useLocation()
	const history = useHistory()
	const params = queryString.parse(location.search)
	const isLegalFlow = useSelector(getIsLegalFlow)
	const user_id = useSelector(getUserId)
	const upsell_test = params?.upsell_test || useSelector(getUpsellPrice)
	const initial_price = params?.initial_price || useSelector(getInitialPrice)

	const [isActive, setIsActive] = useState(false)
	const [upsells, setUpsells] = useState(upsellsList)

	useEffect(() => {
		setTimeout(() => {
			if (pathname === '/upsell1') {
				ampEvent('upsell_shown_1')
			}
			if (pathname === '/upsell2') {
				ampEvent('upsell_shown_2')
			}
			if (pathname === '/upsell3') {
				ampEvent('upsell_shown_3')
			} else if (pathname === '/upsell4') {
				ampEvent('upsell_shown_4')
			}
		}, 0)

		setTimeout(() => {
			setIsActive(true)
		}, 350)
	}, [pathname])

	const updateUpsellsStatus = (upsellType, value) => {
		switch (upsellType) {
			case upsellsTypes.UPSELL1: {
				ampSetUserProperty(
					'upsell_upgrade_1',
					`${value ? 'upgraded' : 'declined'}`,
					user_id,
				)
				break
			}
			case upsellsTypes.UPSELL2: {
				ampSetUserProperty(
					'upsell_upgrade_2',
					`${value ? 'upgraded' : 'declined'}`,
					user_id,
				)
				break
			}
			case upsellsTypes.UPSELL3: {
				ampSetUserProperty(
					'upsell_upgrade_3',
					`${value ? 'upgraded' : 'declined'}`,
					user_id,
				)
				break
			}
			case upsellsTypes.UPSELL4: {
				ampSetUserProperty(
					'upsell_upgrade_4',
					`${value ? 'upgraded' : 'declined'}`,
					user_id,
				)
				break
			}
			default: {
				console.log('Upsell not found.')
			}
		}

		setUpsells(
			upsells.map(upsell => {
				if (upsell.type === upsellType) {
					upsell.isSelected = value
				}

				return upsell
			}),
		)
	}

	const onBtnClick = (path, next, isUpgrading) => {
		updateUpsellsStatus(path, isUpgrading)

		if (next === '/bag') {
			history.push({
				pathname: next,
				search: isLegalFlow
					? paramsToQuery({ user_id, external_id: user_id })
					: paramsToQuery({
							user_id,
							external_id: user_id,
							upsell_test,
							initial_price,
					  }),
				state: { bag: upsells },
			})

			return
		}

		history.push({
			pathname: next,
			search: isLegalFlow
				? paramsToQuery({ user_id, external_id: user_id })
				: paramsToQuery({
						user_id,
						external_id: user_id,
						upsell_test,
						initial_price,
				  }),
		})
	}

	const renderUpsell = () => {
		switch (pathname) {
			case '/upsell1': {
				return (
					<>
						<Header1 />
						<UpsellMain1 upsell="upsell1" />
						<Footer
							onUpgradeBtnClick={() => {
								onBtnClick(upsellsTypes.UPSELL1, upsellsTypes.UPSELL2, true)
							}}
							onSkipBtnClick={() => {
								onBtnClick(upsellsTypes.UPSELL1, upsellsTypes.UPSELL2, false)
							}}
						/>
					</>
				)
			}
			case '/upsell2': {
				return (
					<>
						<Header2
							title={
								<Fragment>
									<span>Add new improvement </span>tools to your order
								</Fragment>
							}
							subtitle={
								<Fragment>
									Try new facial expressions. <br />
									Play over photo app features and explore different looks
								</Fragment>
							}
						/>
						<UpsellMain2 />
						<Footer
							onUpgradeBtnClick={() => {
								onBtnClick(upsellsTypes.UPSELL2, upsellsTypes.UPSELL3, true)
							}}
							onSkipBtnClick={() => {
								onBtnClick(upsellsTypes.UPSELL2, upsellsTypes.UPSELL3, false)
							}}
						/>
					</>
				)
			}
			case '/upsell3': {
				return (
					<>
						<Header2
							title={
								<Fragment>
									What animal do you<span> resemble most?</span>
								</Fragment>
							}
							subtitle={
								<Fragment>
									This new AI-powered feature will perfectly find your animal
									look-alike and create an awesome collage!
								</Fragment>
							}
						/>
						<UpsellMain1 upsell="upsell3" />
						<Footer
							onUpgradeBtnClick={() => {
								onBtnClick(upsellsTypes.UPSELL3, upsellsTypes.UPSELL4, true)
							}}
							onSkipBtnClick={() => {
								onBtnClick(upsellsTypes.UPSELL3, upsellsTypes.UPSELL4, false)
							}}
						/>
					</>
				)
			}
			case '/upsell4': {
				return (
					<>
						<Header2
							title={
								<Fragment>
									What’s your
									<br />
									<span>DNA ancestry?</span>
								</Fragment>
							}
							subtitle={
								<Fragment>
									Our exceptionally accurate algorithm will analyze features of
									your face and tell your ethnic background
								</Fragment>
							}
						/>
						<UpsellMain1 upsell="upsell4" />
						<Footer
							onUpgradeBtnClick={() => {
								onBtnClick(upsellsTypes.UPSELL4, '/bag', true)
							}}
							onSkipBtnClick={() => {
								onBtnClick(upsellsTypes.UPSELL4, '/bag', false)
							}}
						/>
					</>
				)
			}
			default: {
				return <p>Component not found</p>
			}
		}
	}

	return (
		<div className={`upsell ${isActive ? 'upsell--active' : ''}`}>
			{renderUpsell()}
		</div>
	)
}

export { Upsell }
